import type { JsonDataItem } from '../types';
import type { VisibilityCondition } from './visibility-condition.interfaces';
import { VisibilityConditionBase } from './visibility-condition-base';

export class RecordLinkVisibilityCondition extends VisibilityConditionBase {
  constructor(fieldCondition: VisibilityCondition) {
    super(fieldCondition);
  }

  public runVisibilityCondition(currentData: JsonDataItem): boolean {
    // if `requireStepVisibilityCheck` is false, it means there is no RECORDLINK condition and a field can be shown/evaluated by other rules
    if (!currentData.requireStepVisibilityCheck) {
      return false;
    }

    const stepId = this.fieldCondition.stepId?.toString();
    const parentId = this.fieldCondition.parentId?.toString();

    // Prefer the new per-button results map when available
    const newResultsMap =
      currentData.stepVisibilityRecordLinkConditionResults as
        | Record<string, Record<string, boolean>>
        | undefined;

    if (newResultsMap !== undefined && parentId !== undefined) {
      if (!(parentId in newResultsMap)) {
        // parentId not in results map — no condition applies, default to visible
        return false;
      }
      const innerMap = newResultsMap[parentId];
      const isConditionMet =
        stepId !== undefined ? innerMap[stepId] : undefined;
      if (isConditionMet !== undefined) {
        return !isConditionMet;
      }
      // stepId not in inner map — no condition applies, default to visible
      return false;
    }

    // Fall back to old single-key map
    const stepToVisibility =
      currentData.stepVisibilityRecordLinkConditionResult as
        | Record<string, boolean>
        | undefined;
    // fail-closed: cannot evaluate a required condition without stepId or the map
    if (stepId === undefined || stepToVisibility === undefined) {
      return true;
    }
    const isConditionMet = stepToVisibility[stepId];
    if (isConditionMet !== undefined) {
      return !isConditionMet;
    }
    // if the specific step's condition result is not found, default to visible
    return false;
  }
}
